// extracted by mini-css-extract-plugin
module.exports = {"protocol":"styles_protocol__ysIGH","file":"styles_file__3cBF1"};